import Vue from 'vue'

// import the module
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

// define the plugin and pass object for config
Vue.use(Loading, {
    color: '#007bff',
    width: 64,
    height: 64,
    backgroundColor: '#000000',
    opacity: 0,
    zIndex: 999
});
